import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const PieChart = ({ data, name }) => {

    const graphData = data?.map(item => ({
        name: item?.[name] ?? name,
        y: item?.hits
    }));

    const pieOptions = {
        colors: ['#a1c1e0', '#C1C1C1', '#AD6ca5', '#787878', '#701540'],
        chart: {
            type: 'pie',
        },
        title: {
            text: '',
        },
        tooltip: {
            pointFormat: '{point.y} Visits ({point.percentage:.1f}%)',
        },
        plotOptions: {
            pie: {
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                        // Only show label if percentage is >= 10%
                        if (this.percentage >= 10) {
                            return `${this.point.name}<br/>${this.percentage.toFixed(1)}%`;
                        }
                        return null; // Hide label for < 10%
                    },
                },
            },
        },
        series: [
            {
                name: name,
                data: graphData,
            },
        ],
    };
    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={pieOptions} />
        </>
    )
}
export default PieChart